import { useSelector } from "react-redux"
import { SecurityExpression } from "../proto/generated/security"
import { StrategyExpressionMetaDataType } from "../reducer/common.reducer"
import { selectStrategyExpressionsMetaData } from "../selectors/common"
import { selectUserSecurityExpressions } from "../selectors/security"
import { useMemo } from "react"

const useSecurityExpressionToName = () => {
    const strategyExpressionsMetaData: StrategyExpressionMetaDataType[] = useSelector(selectStrategyExpressionsMetaData)
    const savedExpressions: SecurityExpression[] | undefined = useSelector(selectUserSecurityExpressions)

    const expressionToName = useMemo(() => {
        const expressionToName = new Map<string, string>()
        if(savedExpressions){
            savedExpressions.forEach((exp) => {
                expressionToName.set(exp.expression, exp.name)
            })
        }
        strategyExpressionsMetaData.forEach((exp) => {
            expressionToName.set(exp.expression, exp.name)
        })
        return expressionToName
    }, [savedExpressions])

    return expressionToName
}

export default useSecurityExpressionToName